<template>
  <div class="customer-service">
    <p>
      <strong>Need assistance? We can help!</strong>
    </p>
    <p>
      <span class="customer-service-label">Call Us:</span>
      <CustomerServicePhoneLink :with-hours-short="true" />
    </p>
    <p>
      <span class="customer-service-label">Email Us:</span>
      <a
        :href="`mailto:${customerServiceEmailOverride || metadata.customerService.email}`"
        >{{ customerServiceEmailOverride || metadata.customerService.email }}</a
      >
    </p>
    <p v-if="passageOfTitleStatement">
      Please call at
      <CustomerServicePhoneLink :with-hours-long="true" /> if you'd like to
      arrange your own shipment or pickup option.
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CustomerServiceFooter',
  props: {
    customerServiceEmailOverride: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['cart']),
    passageOfTitleStatement() {
      return this.cart.passage_of_title_statement
    },
  },
  created() {
    this.metadata = useMetadata()
  },
}
</script>

<style scoped></style>
